import type { TMessages } from '@/types/TMessages'

export const messages = { readMoreText: 'Читайте также:', subscribeBtnText: 'Подписаться' } satisfies TMessages
